
<script>
  import MatchOddComponent from '../../../../components/common/match/match-odd-component';
  const getDirectOutrightName = (outright) => {
    const outcomeName = outright.outcomes[0] ? ` - ${outright.outcomes[0].name}` : '';
    return `${outright.name}${outcomeName}`;
  };
  export default {
    name: 'OutrightsTabMarket',
    functional: true,
    props: {
      tab: {
        type: Object,
        required: true,
      },
    },
    render(h, { props, parent }) {
      const showBettingEndDate = APP_SETTINGS.settings.showBettingEndDate;
      const multiListNodes = props.tab.multiOutrights.map((outright, idx) => {
        return <div class="bto-sb-widget bto-sb-event-mormarket-market bto-sb-widget-category bto-sb-category-outrights" key={`mo_${idx}`}>
          <div class="bto-sb-event-mormarket-market-name">
            <h4>{outright.name}</h4>
            { showBettingEndDate ? <div class="bto-sb-category-outrights-dates">
                <span class="bto-sb-category-outrights-end-date">{parent.t("OutrightEndDate")}: {outright.endDate}</span>
                <span class="bto-sb-category-outrights-end-betting">{parent.t("OutrightEndBetting")}: {outright.bettingEndDate}</span>
              </div> : <div class="bto-sb-category-outrights-dates">
                <span class="bto-sb-category-outrights-end-date">{parent.t("OutrightEndDate")}: {outright.endDate}</span>
              </div>
            }
          </div>
          <div class="bto-sb-event-mormarket-market-odd">
            <span>
              {...outright.outcomes.slice(0, Math.ceil(outright.outcomes.length / 2)).map((o, oIdx) =>
                <MatchOddComponent match={outright} outcome={o} isOutright={true} isOutrightInDetails={true} key={`mo_s1_${oIdx}`} />
              )}
            </span>
            <span>
              {...outright.outcomes.slice(Math.ceil(outright.outcomes.length / 2, outright.outcomes.length)).map((o, oIdx) =>
                <MatchOddComponent match={outright} outcome={o} isOutright={true} isOutrightInDetails={true} key={`mo_s2_${oIdx}`} />
              )}
            </span>
          </div>
        </div>;
      });

      const directNodes = props.tab.directOutrights.map((outright, idx) => {
        return <div class="bto-sb-event-mormarket-market-odd bto-sb-event-mormarket-outrights-date" key={`do_${idx}`}>
          <span>
            {getDirectOutrightName(outright)}
            { showBettingEndDate ? <span class="bto-sb-market-outrights-dates">
                <i class="bto-sb-market-outrights-end-date">{parent.t("OutrightEndDate")}: {outright.endDate}</i>
                <i class="bto-sb-market-outrights-end-betting">{parent.t("OutrightEndBetting")}: {outright.bettingEndDate}</i>
              </span> :
              <span class="bto-sb-market-outrights-dates">
                <i class="bto-sb-market-outrights-end-date">{parent.t("OutrightEndDate")}: {outright.endDate}</i>
              </span> }
          </span>
          <span>
            <MatchOddComponent match={outright}
              outcome={outright.outcomes[0]}
              isOutright={true}
              isDirectOutright={true}
              isOutrightInDetails={true} />
          </span>
        </div>;
      });

      return [
        directNodes.length > 0 && <div class="bto-sb-event-mormarket-market">
          <div class="bto-sb-event-mormarket-market-outrights-single">
            <div class="bto-sb-event-mormarket-market-name">
              <h4>{parent.t('M.DirectBets')}</h4>
            </div>
            {...directNodes}
          </div>
        </div>,
        ...multiListNodes
      ];
    },
  };
</script>